import styled from 'styled-components'

export const Sidebar = styled.aside`
    width: 220px;
    background: #eef3fb;
    border-radius: 16px;
    padding: 18px;
    box-shadow: inset 0 0 0 1px #d8e3f2;

    @media (max-width: 1000px) {
        width: 100%;
    }
`

export const SidebarLabel = styled.label`
    display: block;
    font-size: 18px;
    font-weight: 700;
    color: #39598a;
    margin-bottom: 12px;
`
